
<div mat-dialog-title><mat-icon class="align-middle" style="margin-right: 8px;">key</mat-icon>{{ 'Impersonation' | translate:locale.language }}</div>
<div mat-dialog-content>
  <div class="row" id="impersonation-selection">
    <p>Select a user to impersonate:</p>
    <!-- Search field -->
    <div style="display: flex;">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label for="qa-search-admins">{{ 'Search by name, email, or admin ID' | translate:locale.language }}</mat-label>
        <input matInput type="text" id="qa-search-admins" minlength="3" autocomplete="off" [formControl]="searchControl" />
        <button *ngIf="searchControl.dirty" matIconSuffix mat-icon-button [attr.aria-label]="'Clear' | translate:locale.language" (click)="resetSearch()">
          <mat-spinner *ngIf="requestInProgress; else clear" diameter="14" class="search-spinner"></mat-spinner>
          <ng-template #clear><mat-icon>close</mat-icon></ng-template>
        </button>
      </mat-form-field>
    </div>
    <!-- Loading progress -->
    <div style="min-height: 6px">
      <app-loading [isCircle]="false" [hasLoaded]="!requestInProgress" [hasFailed]="!!lastError" (retryClicked)="fetchData()" [failTitle]="lastError"></app-loading>
    </div>

    <div class="table-container">
      <table mat-table [dataSource]="dataSource">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let element">
            <span [matTooltip]="getTooltip(element)" matTooltipShowDelay="500" matTooltipPosition="right">{{getDisplayName(element)}}</span>
          </td>
        </ng-container>
        
        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let element"> {{element.email}} </td>
        </ng-container>
    
        <!-- Tenant Column -->
        <ng-container matColumnDef="tenant">
          <th mat-header-cell *matHeaderCellDef> Tenant </th>
          <td mat-cell *matCellDef="let element"> {{element.tenantName}}</td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row class="clickable" *matRowDef="let element; columns: displayedColumns;" (click)="onSelectionChanged(element)">
        </tr>
      </table>
    </div>
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" [length]="lastResponse?.totalItemCount || 0" [pageSize]="pageSize" 
      [showFirstLastButtons]="true" (page)="onPageEvent($event)">
    </mat-paginator>
  </div>
</div>
<div mat-dialog-actions class="button-row right">
  <button mat-stroked-button id="close" mat-dialog-close>{{ 'Close' | translate:locale.language }}</button>
</div>